// extracted by mini-css-extract-plugin
export default {"root":"LengthCounter_root__A4mea","rootSuccess":"LengthCounter_rootSuccess__UXjjv","rootFail":"LengthCounter_rootFail__AAV8S"};